import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../App.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAddItemToCart } from "../../../app/CartSlice";
import Npcard from "../Products/Card";
import ProductService from "../../../Redux/Services/ProductService";

const ProductList = ({ currProductList }) => {
  const [cartPopUpOpen, setCartPopUpOpen] = useState();
  const [currCart, setCurrCart] = useState();
  const [currentlySelected, setCurrentlySelected] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onAddToCart = (product) => {
    dispatch(setAddItemToCart(product));
  };

  const handleClick = () => {
    navigate("/productdetails");
  };

  const handleViewAllClick = () => {
    navigate("/products");
  };

  const handleCartPopUp = () => {
    setCartPopUpOpen(false);
  };

  const handleCartPopUpChange = (number) => {
    setCurrCart(number);
  };

  const fetProductDetails = async (code) => {
    const response = await ProductService.productInvetoryData({ productCode: code });
    console.log(response.data);
    return response.data;
  }

  return (
    <>
      {currProductList?.map((product, idx) => (
        <Npcard
          product={product}
          currCart={currCart}
          productInfo={async () => await fetProductDetails(product.code)}
          handleCartPopUpChange={handleCartPopUpChange}
        />
      ))}
    </>
  );
};

export default ProductList;


// import React from "react";
// import Npcard from "../Products/Card";
// import triphala from "../../../Assests/productImages/shoot3/AMIRTHASARKARAI 2.png";
// import avuriElai from "../../../Assests/productImages/shoot3/INDUKANTA 2.png";
// import dhanvantharaVati from "../../../Assests/productImages/shoot3/DHANVANTHARA 2.png";
// import silajituBhasmam from "../../../Assests/productImages/shoot3/SILAJITU 2.png";  

// const hardcodedProducts = [
//   {
//     id: 1,
//     code: "CH001",
//     name: "AMIRTHASARKARAI CHOORNAM ",
//     imageName:triphala,
//     productPackageDetails: [
//       { packageSize: "100gm" },
//       { packageSize: "250gm" }
//     ]
//   },
//   {
//     id: 2,
//     code: "CH002",
//     name: "INDUKANTA GHRITAM  ",
//     imageName:avuriElai,
//     productPackageDetails: [
//       { packageSize: "100gm" },
//       { packageSize: "250gm" }
//     ]
//   },
//   {
//     id: 3,
//     code: "CH003",
//     name: "Dhanvanthara vati",
//     imageName:dhanvantharaVati,
//     productPackageDetails: [
//       { packageSize: "100gm" },
//       { packageSize: "250gm" }
//     ]
//   },
//   {
//     id: 4,
//     code: "CH004",
//     name: "Silajitu Bhasmam",
//     imageName:silajituBhasmam,
//     productPackageDetails: [
//       { packageSize: "100gm" },
//       { packageSize: "250gm" }
//     ]
//   }
// ];

// const ProductList = () => {
//   return (
//     <>
//       {hardcodedProducts.map((product) => (
//         <Npcard
//           key={product.id}
//           product={product}
//           productInfo={async () => [
//             {
//               packageCode: "100gm",
//               unitPrice: 150,
//               finalPrice: 120,
//               discountPercentage: 20,
//             },
//             {
//               packageCode: "250gm",
//               unitPrice: 300,
//               finalPrice: 240,
//               discountPercentage: 20,
//             },
//           ]}
//         />
//       ))}
//     </>
//   );
// };

// export default ProductList;